import { goToLogin } from '@xgimi-private/user-center';

import { getStore } from '@/store';
import State from '@/store/State';

import BaseComponent, { getClassName } from '../Base';

export const mapStateToProps = (storeState: State) => ({
  storeState,
});

interface Props {
  // Store状态
  storeState?: State,
}

/**
 * Store组件
 */
export default class <P = Record<string, any>, S = Record<string, any>, SS = any> extends BaseComponent<P & Props, S, SS> {
  // Store
  protected store = getStore();

  // Store state
  protected get storeState(): State {
    return this.props.storeState!;
  }

  // 获取Store dispatch
  protected get dispatch(): any {
    const dispatch: any = this.store.dispatch;
    return dispatch;
  }

  /**
   * 是否已登录
   * @param isLogin 没登录时是否登录
   */
  protected isLoggedIn = (isLogin = false): boolean => {
    const isLoggedIn = !!this.storeState.userCenter.deviceInfo || !!this.storeState.userCenter.userInfo;
    if (!isLoggedIn && isLogin && !this.storeState.userCenter.isGettingUserInfo) {
      goToLogin();
    }
    return isLoggedIn;
  };
}

export { getClassName };
